// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"children_age_input_inputContainer__3Q0EI"};